import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.VehicleModel.List.IRequest;
type Response = Api.Core.VehicleModel.List.IResponse;
type Headers = Api.Core.VehicleModel.List.IHeaders;
const url = '/api/ProductManagement/VehicleModel';
export default async function vehicleModelListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
